import { Status } from '../models/status.interfaces';

export const StandardSkyMilesMedallionBannerStatusMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SKYMILES® MEMBER',
    level: '0',
    name: 'skymiles'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const StandardSkyMilesMedallionBannerStatusWithLifetimeMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: 'skymiles'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const StandardSkyMilesMedallionBannerWithSkyPriorityStatusMocks: Status =
  {
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority',
      active: true
    },
    tier: {
      title: '2023 CURRENT STATUS: ',
      subtitle: 'SKYMILES® MEMBER',
      level: '0',
      name: 'skymiles'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };

export const StandardSkyMilesMedallionBannerWithSkyPriorityAndLifetimeStatusMocks: Status =
  {
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority',
      active: true
    },
    tier: {
      title: '',
      subtitle: '',
      level: '0',
      name: 'skymiles'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };

export const MedallionBannerWithAccountStatusMocks: Status = {
  priority: {
    label: 'SKY PRIORITY',
    url: '/us/en/check-in-security/sky-priority',
    active: true
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: 'skymiles'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};
